import { render, staticRenderFns } from "./AccessKey.vue?vue&type=template&id=1fe08beb&scoped=true"
import script from "./AccessKey.vue?vue&type=script&lang=ts"
export * from "./AccessKey.vue?vue&type=script&lang=ts"
import style0 from "./AccessKey.vue?vue&type=style&index=0&id=1fe08beb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe08beb",
  null
  
)

export default component.exports